<template>
    <footer id="footer" class="footer-modern" role="contentinfo">
        <div class="back-to-top-container">
            <a class="back-to-top" href="#top" title="Back to top of page">Back to top <span class="caret"></span></a>
        </div>
        <div class="foot h-card">
            <nav class="footer-links" role="navigation" aria-label="Institutional Footer Navigation">
                <a href="http://www.utmb.edu" class="footer-link-utmbedu" title="UTMB home">UTMB.edu</a>
                <a href="http://www.utmbhealth.com" class="footer-link-utmbhealthcom" title="UTMB Health patient care">UTMBHealth.com</a>
                <a href="http://www.utmb.edu/map/" class="footer-link-maps" title="UTMB maps and directions">Maps / Directions</a>
                <a href="http://www.utmb.edu/site-policies/" class="footer-link-policies" title="UTMB Health site policies and required links">Policies / Required Links</a>
            </nav>
            <div class="footer-copy">
                <div>
                    &copy; <span id="footer-copyright-date"></span>
                    <a class="p-name u-url" href="http://www.utmb.edu/" title="UTMB Health, The University of Texas Medical Branch">
                        <span class="p-org">The University of Texas Medical Branch at Galveston</span>
                    </a>
                    &nbsp; Member,
                    <span class="p-org h-card">Texas Medical Center®</span>
                    <br />
                    <div v-if="useFooterSitefinityLogin">
                        <span v-if="useProdLoginUrls" class="utmbsf-footer-login">
                            <text>UTMB Sitefinity: </text>
                            <a href="https://www.utmb.edu/sitefinity/" title="Log into UTMB Sitefinity on www.utmb.edu">WWW Login</a>
                            <span class="pipe">|</span>
                            <a href="https://intranet.utmb.edu/sitefinity/" title="Log into UTMB Sitefinity on intranet.utmb.edu">Intranet Login </a>
                        </span>
                        <span v-else class="utmbsf-footer-login">
                            <a href="/sitefinity/" title="UTMB Siteifnity Web CMS">Sitefinity Login</a>
                        </span>
                        <!--<span v-if="siteId != null">
                            <span class="pipe">|</span>
                            <a v-bind:href="siteLoginUrl" title="Log into this UTMB Sitefinity site">This Site</a>
                        </span>-->
                    </div>
                </div>
            </div>
            <div class="footer-logo">
                <a id="brand" class="branding" href="http://www.utmb.edu/" title="UTMB Health, The University of Texas Medical Branch"><span>UTMB Health</span></a>
            </div>
        </div>
    </footer>
</template>

<script>
import { mapState } from 'vuex';

export default {
    name: "Footer",
    data() {
        return {
            siteLoginUrl: "/sitefinity/"
        }
    },
    created() {
        this.setSiteLoginUrl();
    },
    computed: mapState([
        "siteId",
        "useFooterSitefinityLogin",
        "useProdLoginUrls"
        ]),
        methods: {
            setSiteLoginUrl() {
                this.siteLoginUrl = "/sitefinity/?sf_site=" + this.siteId;
                //return siteLoginUrl; ///sitefinity/?sf_site={{siteId}}
            }
        }

};
</script>
